import shortly from 'vuex-shortly'
import { EPAY_CREATE, EPAY_PRODUCTS, NOTIFICATIONS_INCLUDE } from '@store/types'
import graphQL from '@graphQL'
import EpayProducts from '@graphQL/queries/EpayProducts'
import axios from 'axios'

const state = {
  epayProducts: []
}

const getters = {
  [EPAY_PRODUCTS]: 'epayProducts'
}

const mutations = {
  [EPAY_PRODUCTS]: (state, payload) => {
    state.epayProducts = payload
  }
}
const actions = {
  [EPAY_PRODUCTS]: ({ commit }, payload) => {
    return graphQL(EpayProducts).then(response => {
      if (response.data.data.epayProducts) {
        commit(EPAY_PRODUCTS, response.data.data.epayProducts)
      }
    })
  },
  [EPAY_CREATE]: async ({ dispatch }, payload) => {
    try {
      const response = await axios.post('/giftcards/bulk-buy-epay ', payload)
      return response.data
    } catch (error) {
      const errorMessage = error.response.status === 403 ? 'Você não tem permissão para realizar esta ação!' : 'Ocorreu um erro!'
      dispatch(NOTIFICATIONS_INCLUDE, Error(errorMessage))
      return error
    }
  }
}

export default shortly({ state, getters, mutations, actions })



// WEBPACK FOOTER //
// ./src/store/modules/epay.js